import React from 'react';

import './requiredDotComponent.css';

const RequiredDotComponent = () => {
  return <div className="et-n-input-required-dot" />;
};

export default RequiredDotComponent;
